import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Switch,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import clsx from "clsx";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { format } from "date-fns";
import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addHolidays, getHolidays } from "redux/modules/holidaySlice";
import ConfigSmartServiceService from "services/ConfigSmartServiceService";
import DatetimeService from "services/DatetimeService";
import * as yup from "yup";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import DepartmentService from "services/DepartmentService";
import { get } from "lodash";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function createData(a, b, c) {
  return { a, b, c };
}

const useStyles = makeStyles((theme) => ({
  warpListVisa: {
    marginTop: 50,
  },
  warpButton: {
    marginTop: 30,
    display: "flex",
    justifyContent: "space-between",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpForm: {
    marginTop: 30,
  },
  warpTabs: {
    marginTop: 30,
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },
  buttonViewDetail: {
    // width: 150,
    backgroundColor: "#00D0FF",
    marginRight: 10,
  },
  warpButtonDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonStatusDetail: {
    backgroundColor: "white",
    padding: 5,
    borderRadius: "50%",
    boxShadow: "0px 0px 2px 2px rgba(23, 43, 77, 0.2)",
  },
  warpData: {
    marginTop: 20,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    backgroundColor: "#1094D8",
    color: "white",
  },
  iconStatus: {
    color: "#2DCE98",
    marginRight: 5,
  },
  warpButtonSave: {
    textAlign: "right",
    marginTop: 30,
  },
  buttonSave: {
    marginLeft: 5,
    width: 120,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  wrapDateControl: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: 15,
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  dateControl: {
    marginRight: 5,
    width: "100%",
  },
  btnEdit: {
    color: "white",
    backgroundColor: "#2DCE98",
    marginLeft: 10,
  },
  btnRemove: {
    color: "white",
    backgroundColor: "#F53C56",
    marginLeft: 10,
  },
  warpRowDialog: {
    marginTop: 10,
  },
  dtitle: {
    color: "#40B8D4",
  },
  d2title: {
    color: "#172B4D",
    paddingBottom: 10,
  },
  textDialog: {
    width: "100%",
  },
  warpDialog: {
    padding: "30px",
    minWidth: "600px",
    minHeight: "200px",
  },
}));

function DepartmentPage() {
  const { t, i18n } = useTranslation();

  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  const [date, setDate] = React.useState(new Date());

  const [Data, setData] = React.useState([]);
  const masterData = useSelector(selectMasterData);
  const smartservices = get(masterData, "smartservice", []);
  const department = get(masterData, "department", []);

  useEffect(async () => {
    await dispatch(
      getMasterData({
        department: true,
      })
    );
  }, []);

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="หน่วยงานรับรอง" />

      <div className={classes.warpSubHeader}>
        <AdminTitle2 subTitle="จัดการหน่วยงานรับรอง" />
        <div className={classes.wrapDateControl}>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            className={classes.buttonDialogSave}
            href={"/admin/setting/addDepartment"}
          >
            <AddIcon />
            เพิ่มหน่วยงานรับรอง
          </Button>
        </div>
      </div>

      <div className={classes.warpData}>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell
                  className={classes.tableHead}
                  style={{ width: 200 }}
                >
                  หน่วยงานรับรอง
                </StyledTableCell>
                <StyledTableCell className={classes.tableHead}>
                  Tax ID
                </StyledTableCell>
                {/* <StyledTableCell className={classes.tableHead}>
                  ใช้งาน
                </StyledTableCell> */}

                <StyledTableCell
                  className={classes.tableHead}
                  style={{ width: 200, textAlign: "center" }}
                >
                  จัดการ
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {department.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell style={{ width: 500 }}>
                    {row?.departmentName}
                  </StyledTableCell>
                  <StyledTableCell>{row?.taxID}</StyledTableCell>
                  {/* <StyledTableCell className={classes.center}>
                    <Switch
                      checked={row?.status}
                      onChange={async (event) => {
                        const res = await DepartmentService.updateStatus({
                          empId: row?.empId,
                          status: event.target.checked,
                        });
                        if (res.status) {
                          await dispatch(
                            getMasterData({
                              department: true,
                            })
                          );
                        }
                      }}
                    />
                  </StyledTableCell> */}
                  <StyledTableCell style={{ width: 200, textAlign: "center" }}>
                    <div className={classes.warpButtonDetail}>
                      <Button
                        size="small"
                        color="primary"
                        className={classes.btnEdit}
                        href={
                          "/admin/setting/detaildepartment/" + row?.departmentId
                        }
                      >
                        แก้ไข
                      </Button>
                      {/* <Button
                        size="small"
                        color="error"
                        className={classes.btnRemove}
                      >
                        ลบ
                      </Button> */}
                    </div>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Paper>
  );
}

export default DepartmentPage;
